// Note: Deprecated

export const intializeStoreActionTypes = {
  INITIALIZE_STORE: "INITIALIZE_STORE",
};

function initializeStoreAction() {
  return {
    type: intializeStoreActionTypes.INITIALIZE_STORE,
    payload: {},
  };
}

export default function initializeStore(store) {
  store.dispatch(initializeStoreAction());
  return store;
}
